export default __webpack_public_path__ + "static/media/Trinket of Old Acheron.efb51a35.jpg";